import { useCallback, useContext } from 'react';
import { CartContext } from '../../core/cartContext';

const useUpdateCartItemQuantity = (onItemRemove?: (sku: string) => void) => {
    const { cart } = useContext(CartContext);

    return useCallback(
        (sku: string, quantity: number) => {
            cart.updateItemQuantity(sku, quantity);
            if (quantity === 0 && onItemRemove) {
                onItemRemove(sku);
            }
        },
        [cart, onItemRemove]
    );
};

export default useUpdateCartItemQuantity;
